<template>
  <div class="wrap" v-loading="loading"  element-loading-text="请稍等...">
    <div class="wrap-top">
      <div class="top-left">
        <p style="color:#4095E5" class="title">
          {{form.training_title}}</p>
        <div class="left-middle" style="color:#9A9A9A">
          <span>考试时长：{{form.exam_duration}}分钟</span>
          <span style="margin-left: 14px">总分：{{form.total_scores}}分</span>
          <span style="margin-left: 14px">合格分：{{form.pass_scores}}分</span>
        </div>
        <div style="color:#9A9A9A" class="left-bottom">题型：{{form.question_types}}</div>
      </div>
      <div class="top-right">
        <div class="right-item" style="background-color: #4095E5">
          <p class="top">需参加考试总人数</p>
          <p class="bottom">{{form.user_total}}<span>人</span></p>
        </div>
        <div class="right-item" style="background-color: #E99D42">
          <p class="top">实际加考试总人数</p>
          <p class="bottom">{{form.join_user_total}} <span>人</span></p>
        </div>
        <div class="right-item" style="background-color: #81B337">
          <p class="top">考试合格总人数</p>
          <p class="bottom">{{form.pass_user_total}} <span>人</span></p>
        </div>
        <div class="right-item" style="background-color: #BFBF3D" >
        <p class="top">一次性合格率</p>
        <p class="bottom">{{form.first_pass_rate}} <span>%</span></p>
      </div>
      </div>
    </div>
    <div class="wrap-bottom">
      <div class="search-block">
        <el-input placeholder="请输入内容" v-model="keywords" class="search-input"></el-input>
        <el-date-picker v-model="searchDate" type="daterange"  value-format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        <el-button style="background-color: #4787F0;color:#fff;margin-left: 14px;" @click="getTableData">搜索</el-button>
        <el-button style="background-color: #377F7F;color:#fff;float: right" @click="handleExport">导出结果</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column prop="user_phone" label="账号" width="100"></el-table-column>
          <el-table-column prop="user_name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="organization" label="机构/部门" min-width="140"></el-table-column>
          <el-table-column prop="training_time" label="参加培训时间" width="110"></el-table-column>
          <el-table-column prop="best_scores" label="考试分数" width="100"></el-table-column>
          <el-table-column prop="best_ranking" label="排名" width="100"></el-table-column>
          <el-table-column prop="exam_pass" label="是否合格" width="110"></el-table-column>
          <el-table-column prop="exam_times" label="答题次数" width="100"></el-table-column>
          <el-table-column prop="exam_last_time" label="最近考试时间" width="130"></el-table-column>
          <el-table-column prop="" label="操作" width="110">
            <template v-slot  ="{row}">
              <el-button icon="el-icon-view" @click="handleCheck(row)" type="text" size="small">答题情况</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>
  </div>
</template>
<script>
import {getExamDtl, getExamUserDtl} from "@/api/training";

export default {
  name: "examRecord",
  data() {
    return {
      loading: false,
      keywords: '',
      searchDate:[],
      form:{},
      tableData: []
    }
  },
  created() {
    this.getTableData()
    this.getDtl()
  },
  methods:{
    getDtl(){
      if(this.$route.query.id){
        getExamDtl({id: this.$route.query.id}).then(res => {
          this.form = res.data
        })
      }
    },
    getTableData(){
      let params = {
        exam_id: this.$route.query.id,
        keywords: this.keywords,
        start_day: this.searchDate ? this.searchDate[0] : '',
        end_day: this.searchDate ? this.searchDate[1] : '',
      }
      getExamUserDtl(params).then(res => {
        this.tableData = res.data.results
      })
    },
    handleCheck(row){
      this.$router.push({path: '/cloudTraining/exam/answeringStatus',query: {log_id:row.best_log_id,exam_id:this.$route.query.id}})
    },
    handleExport(){
      let params = {
        exam_id: this.$route.query.id,
        keywords: this.keywords,
        start_day: this.searchDate ? this.searchDate[0] : '',
        end_day: this.searchDate ? this.searchDate[1] : '',
        export : true
      }
      getExamUserDtl(params).then(res => {
        let url = res.data.file_url
        this.downloadFile(url)
      })
    },
    downloadFile(url) {
      this.loading= true
      return new Promise((resolve, reject) => {
        const fileName = url.split('/').pop()
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = fileName
        // 这个延迟操作的目的是为了确保浏览器有足够的时间来处理下载操作
        // 这样可以避免在循环中快速触发多个下载操作，导致浏览器无法正确处理下载请求
        link.addEventListener('click', () => {
          setTimeout(() => {
            this.loading= false
            resolve()
          }, 1000)
        })
        link.click()
      }).finally(()=>{this.loading = false})
    },
  }
}
</script>

<style scoped lang="scss">
.wrap{
  margin: 10px 20px;
  box-sizing: border-box;
  .wrap-top{
    display: flex;
    justify-content: space-between;
    .top-left{
      width: 40%;
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 20px;
      border-radius: 3px;
      .title{
        font-weight: bold;
        margin-bottom: 14px;
      }

    }
    .top-right{
      border-radius: 3px;
      background-color: #fff;
      width: 60%;
      display: flex;
      justify-content: space-around;
      padding: 20px;
      box-sizing: border-box;
      .right-item{
        width: 24%;
        height: 100px;
        border-radius: 3px;
        padding: 12px 16px 16px 20px;
        box-sizing: border-box;
        p.top{
          color:#fff;
          font-size: 16px;
          font-weight: bold;
        }
        p.bottom {
          margin-top: 18px;
          color:#fff;
          text-align: center;
          font-size: 28px;
          span{
            font-size: 16px;
          }
        }
      }
    }
  }
  .wrap-bottom{
    .search-block{
      display: inline-block;
      width: 100%;
      padding:20px;
      box-sizing: border-box;
      background-color: #fff;
      margin: 20px 0;
      .search-input{
        width: 300px;
        margin-right: 20px;
        ::v-deep input{
          width: 100%;
        }
      }
    }
  }
}

::v-deep .el-table thead tr th{
  background-color: #2BAEE9;
  color:#fff;
}

</style>